// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { ControlBarComponent } from './control-bar.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [ControlBarComponent],
  declarations: [ControlBarComponent],
})
export class ControlBarModule {}
export { ControlBarComponent };
